import { SVGProps } from 'react';

export const XIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.2054 14.3063L10.785 6.7218H7.89392L14.6084 16.1163L15.4537 17.2981L21.2009 25.3463H24.0919L17.047 15.4881L16.2054 14.3063Z"
        fill="black"
      />
      <path
        d="M28.2131 1.33337H3.78699C2.43184 1.33337 1.33337 2.43184 1.33337 3.78699V28.2131C1.33337 29.5682 2.43184 30.6667 3.78699 30.6667H28.2131C29.5682 30.6667 30.6667 29.5682 30.6667 28.2131V3.78699C30.6667 2.43184 29.5682 1.33337 28.2131 1.33337ZM20.3138 26.6667L14.4971 18.3827L7.21529 26.6667H5.33337L13.6626 17.1938L5.33337 5.33337H11.6862L17.1931 13.176L24.0928 5.33337H25.9747L18.032 14.3676L26.6667 26.6667H20.3138Z"
        fill="black"
      />
    </svg>
  );
};
